<rma-profile-map-cta
  [name]="agent.name"
  [canHaveProperties]="true"
  [skipCache]="true"
  [profileCode]="agent.profileCode"
  [mapUrlParams]="mapUrlParams"
  [mapUrl]="mapUrl"
  [useHref]="true"
  verticalType="Sales"
  profileType="Individual"
  mapType="Review"
  target="_blank" />
